import { type ReactNode } from 'react';
import { Layout } from 'antd';
import { Header } from '../Header';
import { BaseMenu } from '../Menu';
import { extractMenuStructure, dataRoutes } from '@/router/menus';
import { APP_ENV } from '@/utils';
import styles from './index.module.scss';

const { Sider, Content } = Layout;
const menus = extractMenuStructure(dataRoutes);

interface PageLayoutProps {
  children?: ReactNode;
}

function PageLayout({ children }: PageLayoutProps) {
  return (
    <Layout style={{ minHeight: '100vh', background: '#060a13' }} hasSider>
      <Sider collapsible={false} className={styles.sider} width="240">
        <div className={styles.logo}>
          <div className={styles.brandIcon}>W</div>
          <div className={styles.brandText}>
            <span className={styles.brandName}>Web-CAD</span>
            {APP_ENV && APP_ENV !== 'live' && (
              <span className={styles.envBadge}>{APP_ENV.toUpperCase()}</span>
            )}
            {APP_ENV === 'live' && <span className={styles.envBadgeLive}>LIVE</span>}
          </div>
        </div>
        <BaseMenu menu={menus} theme="dark" mode="inline" />
      </Sider>
      <Layout style={{ background: '#060a13' }}>
        <Header />
        <Content className={styles.content}>{children}</Content>
      </Layout>
    </Layout>
  );
}

export const ContentLayout = PageLayout;
